import React from 'react';
import './footer.css'

const Footer = () => {
  return (
    <footer id='footer' className='footer fixed-bottom'>
     <div className="copyright">
      &copy; Copyright{' '}
      
      <strong>
       <span>Health Care</span>
      </strong>
      .All Right Reserved
     </div>

     {/* <div className="credits">
      Designed by <a href="#">SmartShore Team</a>
     </div> */}

    </footer>
  )
}

export default Footer